import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import b04 from "../../../../assets/notarymeet/b04.png"
import b044 from "../../../../assets/notarymeet/b044.png"

import '../notarymeet.css'


function B04() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#343434",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
        {isSmallScreen ? (
          <Image src={b044} alt='b044' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        ) : (
          <Image src={b04} alt='b04' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        )}
       
    </Container>
    
     
    
  )
}

export default B04
